import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';
import {Modal, message ,Progress,Tag} from 'antd';
import moment from 'moment';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {
        key: 'orgName', width: 100,
        label: '所属部门'
    },
    {
        key: 'objectCode', width: 100,
        label: '对象编号'
    },
    {
        key: 'objectName', width: 100,
        label: '对象名称'
    },
    {
        key: 'objectType', width: 100,
        label: '对象类型',
        render: (data) => {
            var objectType = JSON.parse(data)
            if(objectType==0){
                return '专业';
            }else if(objectType==1){
                return '教师';
            }else if(objectType==2){
                return '课程';
            }else if(objectType==3){
                return '班级';
            }else if(objectType==4){
                return '学生';
            }else if(objectType==5){
                return '部门';
            }else if(objectType==6){
                return '团队';
            }else {
                return '未知类型';
            }
        } 
    },
    {
        key: 'targetName', width: 100,
        label: '指标名称',
    },
    {
        key: 'resultScore', width: 100,
        label: '录入总分',
    },
    {
        key: 'auditScore', width: 100,
        label: '审核总分',
    },
    {
        key: 'submitEmployeeName', width: 70,
        label: '录入人'
    },
    {
        key: 'termName', width: 120,
        label: '学期'
    }
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {
        key: 'orgName', width: 100,
        label: '所属部门'
    },
    {
        key: 'objectCode', width: 100,
        label: '对象编号'
    },
    {
        key: 'objectName', width: 100,
        label: '对象名称'
    },
    {
        key: 'objectType', width: 100,
        label: '对象类型',
        render: (data) => {
            var objectType = JSON.parse(data)
            if(objectType==0){
                return '专业';
            }else if(objectType==1){
                return '教师';
            }else if(objectType==2){
                return '课程';
            }else if(objectType==3){
                return '班级';
            }else if(objectType==4){
                return '学生';
            }else if(objectType==5){
                return '部门';
            }else if(objectType==6){
                return '团队';
            }else {
                return '未知类型';
            }
        } 
    },
    {
        key: 'targetName', width: 100,
        label: '指标名称',
    },
    {
        key: 'resultScore', width: 100,
        label: '录入总分',
    },
    {
        key: 'auditScore', width: 100,
        label: '审核总分',
    },
    {
        key: 'submitEmployeeName', width: 70,
        label: '录入人'
    },
    {
        key: 'termName', width: 120,
        label: '学期'
    },
    // {key:'progress', width: 100, label: '审核进度' ,
    //             render:(value) => <Progress percent={parseInt(value)} />  },
    {key:'submitTime', label: '正式提交日期', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
    {key:'resultState', label: '状态', width: 70, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>待提交</Tag>)},
    {type:'action', label: '操作', values: ['submit']}
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('zgcp/targetResult/totalQuery?'+ params.join('&'), Object.assign({
        type: "view"
    }, defaultsParams, newKeyword))
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = [] 
        if(extParams) {
            for(let i = 0; i < columnsArray.length; i++) {
                if(columnsArray[i].key != 'className'&& columnsArray[i].key != 'objectCode'){
                    newArray.push(columnsArray[i])
                }
                if((extParams.objectType == 4 || extParams.objectType == 1 ) && columnsArray[i].key == 'objectCode'){
                    newArray.push(columnsArray[i])
                }
                if(extParams.objectType == 4 && columnsArray[i].key == 'className'){
                    newArray.push(columnsArray[i])
                }
                if(i === 4) {
                    if(extParams.options.length > 0){
                        extParams.options.forEach(o => {
                            var key = o.name;
                            if(key.indexOf("FILEVO-") != -1){
                                newArray.push({
                                    key: o.name,
                                    label: o.value, 
                                    width: 120,
                                    render: (files) => {
                                        if(files && files.length > 0) {
                                            return (
                                                <ol className="upper-alpha">
                                                    {
                                                        files.map((file) => (
                                                            <li><a href={window.base + 'zgcp/enter/file/download?id=' + file.id} target="_blank">{ file.fileName }</a></li>
                                                        ))
                                                    }
                                                </ol>
                                            )
                                        }
                                        return "无";
                                    }
                                })
                            }else{
                                newArray.push({
                                    key: o.name,
                                    label: o.value, 
                                    width: 120
                                })
                            }
                        })
                    }
                    if(extParams.teamDetail && extParams.teamDetail.length > 0){
                        extParams.teamDetail.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value, 
                                width: 120
                            })
                        })
                    }
                }
                if(i === 8) {
                    if(extParams.option2s.length > 0){
                        extParams.option2s.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value, 
                                width: 120
                            })
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(newArray.length > 0 ? newArray :columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: (res.data.dataList || []).map(d => {
            return Object.assign({}, d, {
                height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
            })
        }),
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.resultId,
            checked: false,
            height: (d.fileMaxRow != null ? d.fileMaxRow * 30 : 30)
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}


const getAllInfoByResultId = (keywords) => {
    return fetch.post('zgcp/targetResult/getAllInfoByResultId/' + keywords.id,{type: keywords.type})
    .then(response => {
        return response.payload;
    })
}

const getAllViewByResultId = (keywords) => {
    return fetch.post('zgcp/targetResult/getAllViewByResultId/' + keywords.id,{type: keywords.type})
    .then(response => {
        return response.payload;
    })
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    headers,
    querySearch,
    getAllInfoByResultId,
    getAllViewByResultId
}